import { render, staticRenderFns } from "./SetupScreenSharing.vue?vue&type=template&id=05b3c80b"
import script from "./SetupScreenSharing.vue?vue&type=script&lang=js"
export * from "./SetupScreenSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports